export const lightGrey = '#E1E1E1'; //used in header, button, toast borders
export const text = '#2D2E2C'; //text color
export const brandColor = '#2D2E2C'; // used for bg